import setValue from './setValue';

const CACHE_KEY = 'cacheData';

// Put data to cache
const saveData = (key, data) => (dispatch) => {
  dispatch(setValue(CACHE_KEY, function (cacheData) {
    return {
      ...(cacheData || {}),
      [key]: data
    }
  }))
}

// Get data from cache
const getData = (key) => (dispatch, getState) => {
  const state = getState();
  return state?.main?.[CACHE_KEY]?.[key]
}

export {
  saveData,
  getData
}
